import { getUserInfo, getToken, checkCurrentToken } from "@/api/user";
import { hrefParams, currentOrigin, replaceToOrigin } from "@/utils/location";
import { logout, switchLoginModeGetToken } from "@/api/user";
function error(errorText) {
  return new Error(errorText);
}
const user = {
  state: {
    userInfo: {},
    token: "",
  },

  mutations: {
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo;
    },
    SET_LOGIN_TOKEN(state, { access_token, token }) {
      // 切换登录模式后返回的token字段的key为token，并不是access_token，所以需要短路
      state.token = access_token || token;
      window.localStorage.setItem("token", state.token);
      replaceToOrigin();
    },
  },

  actions: {
    // 获取token
    async getLoginToken({ commit }) {
      const { code } = hrefParams();
      console.log("====================================================");
      console.log(`当前请求的code为：${code}`);
      console.log("====================================================");
      let response;
      try {
        response = await getToken({ code, redirect_uri: currentOrigin });
      } catch (e) {
        throw error("获取token失败");
      }
      if (response.data) {
        commit("SET_LOGIN_TOKEN", response.data);
      }
    },

    // 获取用户信息
    async getUserInfo({ commit }) {
      let response;
      try {
        response = await getUserInfo();
      } catch (e) {
        throw error("获取用户信息失败，请清除浏览器缓存后重新登录");
      }
      if (response.data && response.data.data) {
        commit("SET_USER_INFO", response.data.data);
      }
    },
    // 切换登录模式
    async switchLoginModel({ commit }, query) {
      const key = query["key"].replace(/\s/g, "+");
      try {
        const { data } = await switchLoginModeGetToken(key, query["sysID"]);
        console.log(JSON.stringify(data));
        if (Number(data.data.code) === 200) {
          commit("SET_SWICH_LOGIN_TOKEN", data.data);
        } else {
          throw "获取token失败";
        }
      } catch (e) {
        throw error("获取token失败");
      }
    },
    // 校验token
    async checkCurrentUser() {
      let response;
      try {
        response = await checkCurrentToken();
      } catch (e) {
        throw error("当前token已失效，跳转登录页面重新获取token");
      }
    },
    logout() {
      window.localStorage.removeItem("token");
      logout();
    },
  },
};

export default user;
